import React from 'react';

const Tag = ({ gradientId, text }: { gradientId: string; text: string }) => {
  const rankNumber = text.includes('TOP') ? text.split(' ')[1] : text; // Extract rank number (1, 2, or 3)
  const labelText = text.includes('TOP') ? text.split(' ')[0] : '';

  return (
    <svg
      width="25"
      height="32"
      viewBox="0 0 25 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.426 32L0.273438 25.7488V0H24.7274V25.7488L12.426 32Z"
        fill={`url(#${gradientId})`}
      />
      <foreignObject x="0" y="0" width="25" height="32">
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            color: labelText ? 'white' : '#67708C',
            textAlign: 'center',
            fontWeight: 800,
          }}
        >
          {labelText && (
            <span style={{ fontSize: '9px', lineHeight: '10.55px' }}>
              {labelText}
            </span>
          )}{' '}
          {/* Label Text (if present) */}
          <span style={{ fontSize: '14px', lineHeight: '16.41px' }}>
            {rankNumber}
          </span>{' '}
          {/* Rank Number */}
        </div>
      </foreignObject>
      <defs>
        <linearGradient
          id="normal"
          x1="12.5004"
          y1="0"
          x2="12.5004"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E9ECF3" />
          <stop offset="1" stopColor="#D0D9E5" />
        </linearGradient>
        <linearGradient
          id="top1"
          x1="12.5004"
          y1="0"
          x2="12.5004"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FECA3F" />
          <stop offset="1" stopColor="#FF8706" />
        </linearGradient>
        <linearGradient
          id="top2"
          x1="12.5004"
          y1="0"
          x2="12.5004"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8A8E97" />
          <stop offset="1" stopColor="#626874" />
        </linearGradient>
        <linearGradient
          id="top3"
          x1="12.5004"
          y1="0"
          x2="12.5004"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BC7740" />
          <stop offset="1" stopColor="#AD4B24" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Tag;
